// Ported from the hand-built pages/SciencePage.js.
const IMG = '/images/science';

const page = {
  title: 'The Science',
  hero: {
    title: 'The Science',
    image: `${IMG}/banner.webp`,
    align: 'left',
  },
  blocks: [
    {
      type: 'split',
      variant: 'raised',
      image: `${IMG}/profile.webp`,
      imageAlt: 'A nutritionist reviewing a client’s dietary profile',
      imageSide: 'left',
      groups: [
        {
          heading: 'We Build Your Unique Profile',
          paragraphs: [
            [
              'Our nutritionists use the lifestyle information you provide to inform your unique ',
              'Recommended Dietary Allowance (RDA) and Dietary Reference Intake (DRI), as outlined by the ',
              {
                label: 'National Academy of Sciences Food and Nutrition Board',
                href: 'https://www.nationalacademies.org/fnb/about',
              },
              ' and the ',
              {
                label: 'National Institutes of Health',
                href: 'https://ods.od.nih.gov/HealthInformation/nutrientrecommendations.aspx',
              },
              ' (NIH). Their databases lay the foundation of your nutritional needs so you can thrive ',
              'physically and mentally.',
            ],
          ],
        },
      ],
    },
    {
      type: 'split',
      tone: 'warm',
      variant: 'raised',
      image: `${IMG}/scale.webp`,
      imageAlt: 'Ingredients being weighed on a kitchen scale',
      groups: [
        {
          heading: 'Adapting Our Dishes to You',
          paragraphs: [
            'Our team carefully reviews each chef-made dish to adjust it to your nutritional needs - '
            + 'without sacrificing flavor. We use USDA values to break down the carbohydrate, protein, '
            + 'fat and micronutrient content of each dish. Together with our chef and nutritionist, we '
            + 'determine your ideal portion of protein, veggies, starches and healthy fats so you get '
            + 'the most out of every meal (and snack!).',
          ],
        },
      ],
    },
    {
      type: 'split',
      variant: 'raised',
      image: `${IMG}/measured-grains.webp`,
      imageAlt: 'Measured portions of grains in small bowls',
      imageSide: 'left',
      groups: [
        {
          heading: "But We Know It's Not Just Math",
          paragraphs: [
            'We check in regularly to see how you are feeling and make modifications to future '
            + 'recommendations based on your feedback, as we work toward the meals that suit you best '
            + 'in nutrients and taste. No two people are the same, and our goal is for everyone to '
            + 'feel their best.',
          ],
        },
      ],
    },
    {
      type: 'ctaGroup',
      heading: 'Still Have Questions?',
      actions: [
        { label: 'Contact Us', to: '/contact-form-general' },
        { label: 'Visit FAQ', to: '/faqs'},
      ],
    },
  ],
};

export default page;
